import styles from './Card.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'clsx';

const CardVariantValues = ['outline', 'flat', 'shadow', 'floating'];
function Card(props) {
  const {
    children,
    variant = 'outline',
    bleed = 'default',
    size = 'default',
    className: callerClassName,
    tag
  } = props;
  const className = classNames('dsx-component', callerClassName, styles['card'], styles[`bleed-${bleed}`], styles[`size-${size}`], styles[`variant-${variant}`]);
  return /*#__PURE__*/jsx("div", {
    className: className,
    "data-dsx--card": tag,
    children: children
  });
}

export { Card, CardVariantValues };
